import React, { useEffect } from "react";
import { Routes, Route, useNavigate } from "react-router-dom";
import LogInPaga from "../pages/LogInPage";
import SignUpPage from "../pages/SignUpPage";
import HomePage from "../pages/HomePage";
import NotFoundPaga from "../pages/NotFoundPaga";
import VerifyEmailPaga from "../pages/VerifyEmailPaga";
import VerifyPhonePaga from "../pages/VerifyPhonePage";
import CreateSuccessPage from "../pages/CreateSuccessPage";
import OrderSuccessPage from "../pages/OrderSuccessPage";
import BookingPage from "../pages/BookingPage";
import SelectMasterPage from "../pages/SelectMasterPage";
import SelectServicePage from "../pages/SelectServicePage";
import SelectDatePage from "../pages/SelectDatePage";
import PrivacyPolicyPage from "../pages/PrivacyPolicyPage";
import TermsOfUsePage from "../pages/TermsOfUsePage";
import AppLayout from "./AppLayout";
import { useSelector } from "react-redux";
import { ToastContainer } from "react-toastify";
import UserOrdersPage from "../pages/UserOrdersPage";
import UserProfilePage from "../pages/UserProfilePage";
import { useDispatch } from "react-redux";
import useWindowSize from "../hooks/useWindowSize";
import { resize } from "../store/slice/userSlice";
import { getUserAsyncThunk } from "../store/slice/userSlice";
import GoogleAuthPage from "../pages/GoogleAuthPage";

const config = [
  "/login",
  "/signup",
  "/verify-email",
  "/verify-phone",
  "/success",
  "/auth/google-callback",
  "/privacy-policy",
  "/terms-of-use",
];

const App = () => {
  const token = useSelector((state) => state.userReducer.token);
  const screen = useSelector((state) => state.userReducer.screen);
  const redirect = useNavigate();
  const dispatch = useDispatch();
  const windowSize = useWindowSize();

  useEffect(() => {
    if (windowSize.width <= 678) {
      dispatch(resize({ key: "mobile", value: true }));
    }
    if (windowSize.width > 678 && windowSize.width <= 1024) {
      dispatch(resize({ key: "tablet", value: true }));
    }
    if (windowSize.width > 1024) {
      dispatch(resize({ key: "desktop", value: true }));
    }
  }, [windowSize, dispatch]);

  useEffect(() => {
    if (token) {
      dispatch(getUserAsyncThunk());
    } else {
      !config.includes(window.location.pathname) && redirect("/login");
    }
  }, [token]);

  return (
    <div className="app">
      <ToastContainer />
      <Routes>
        <Route path="/" element={<AppLayout />}>
          <Route index element={<HomePage />} />
          <Route path="/orders" element={<UserOrdersPage />} />
          <Route path="/profile" element={<UserProfilePage />} />
          {screen.desktop ? (
            <Route path="/booking" element={<BookingPage />}>
              <Route index element={<SelectServicePage />} />
              <Route path="/booking/master" element={<SelectMasterPage />} />
              <Route path="/booking/service" element={<SelectServicePage />} />
              <Route path="/booking/date" element={<SelectDatePage />} />
            </Route>
          ) : (
            <>
              <Route path="/booking" element={<BookingPage displayHead={!screen.desktop} />} />
              <Route path="/booking/master" element={<SelectMasterPage displayHead={!screen.desktop} />} />
              <Route path="/booking/service" element={<SelectServicePage displayHead={!screen.desktop} />} />
              <Route path="/booking/date" element={<SelectDatePage displayHead={!screen.desktop} />} />
            </>
          )}
          <Route path="*" element={<NotFoundPaga />} />
        </Route>
        <Route path="/login" element={<LogInPaga />} />
        <Route path="/signup" element={<SignUpPage />} />
        <Route path="/verify-email" element={<VerifyEmailPaga />} />
        <Route path="/verify-phone" element={<VerifyPhonePaga />} />
        <Route path="/auth/google-callback" element={<GoogleAuthPage />} />
        <Route path="/success" element={<CreateSuccessPage />} />
        <Route path="/booking/success" element={<OrderSuccessPage />} />
        <Route path="/payment-callback" element={<OrderSuccessPage />} />
        <Route path="/privacy-policy" element={<PrivacyPolicyPage />} />
        <Route path="/terms-of-use" element={<TermsOfUsePage />} />
        <Route path="*" element={<NotFoundPaga />} />
      </Routes>
    </div>
  );
};

export default App;
